export default "__VITE_ASSET__3fa70799__"